import "./assets/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";

import App from "./App.vue";
import router from "./router";
import cs from "./locales/cs.json";

import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";

import * as Sentry from "@sentry/vue";

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://6507d4016666d63cc0ef27502f6fceea@o447380.ingest.us.sentry.io/4509904559865857",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
});

app.use(PrimeVue, {
  theme: "none",
  locale: cs.cs,
});
app.use(createPinia());
app.use(router);
app.use(ToastService);
app.use(ConfirmationService);

app.mount("#app");
